<template>
  <div class="cfa-root">
    <c-f-a-nav :alert="alertString" contentClass="position-relative">
      <template v-slot:title>
        <div class="w-100 pt-5 text-start mb-3 d-flex justify-content-between align-items-center efwegl">
            <router-link :to="{name: 'Module Pluzz'}">
                <button class="btn cfa-btn-primary d-flex"><i class="fa fa-chevron-left white-color">&nbsp;&nbsp;</i> <span>{{ $t('back_label') }}</span> </button>
            </router-link>
            <div>
                <h1 v-if="modulePluzzPayLoad != null" class="cfa-section-title mb-0 ms-2">
                    {{ getLocalizedContent(modulePluzzPayLoad, 'title')?.toUpperCase() }}
                </h1>
            </div>
        </div>
        <br>
      </template>
      <template v-slot:content>
        <div class="cfa-page">
          <div class="courseIframe d-flex position-relative">
            <div v-show="waitingHttpResponse" class="cfa-page" style="width:100%">
              <div class="d-flex justify-content-center align-items-center oups" style="min-height: 70vh">
                <div class="preloader_center d-flex flex-column">
                  <img src="../../assets/brand/cfa-favicon1.png" alt="cfa preloader">
                  <p class="pl-3 fw-bold"></p>
                </div>
              </div>
            </div>
            <div id="html_container"></div>
            <iframe id="course_iframe" src="" class="col-12" title="Spectorly - Module Content" style="background-color: var(--primary-light-color-2)" v-show="!waitingHttpResponse"></iframe>
          </div>
        </div>
      </template>
    </c-f-a-nav>
    <c-f-a-footer></c-f-a-footer>
  </div>
</template>

<script>
/* eslint-disable */
import CFAFooter from '@/components/nav/CFAFooter.vue'
import CFANav from '@/components/nav/CFANav.vue'
import PreLoader from '@/components/shared/PreLoader.vue'
import {getAPI} from "@/axios-api";

export default {
  name: 'WebContainerPluzzView',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    CFAFooter,
    CFANav,
    PreLoader
  },
  data () {
    return {
      waitingHttpResponse: true,
      alertString: '',
      modulePluzzPayLoad: null,
      url_content: this.url,
      allModulesPluzzNumber: null,
      isLastModulePluzz: false,
      current_stat_module_pluzz: null,
      allStatModulesPluzz: [],
    }
  },
  methods: {
    getLocalizedContent(module, field) {
      if (this.$i18n.locale === 'en' && module[field + '_en']) {
        return module[field + '_en'];
      }
      return module[field];
    }
  },
  async mounted() {
      const iframeEl = document.querySelector('iframe')
      if (iframeEl) {
        iframeEl.onload = () => {
          setTimeout(() => {
            this.waitingHttpResponse = false
          }, 2000)
        }
      }
      document.getElementById('cfa-nav-bottom-swiper').click()

      // Compter les modules accessibles (pluzz)
      await getAPI.get(`module_pluzz/modules/accessible/`).then((res)=> {
        if (res.status == 200 && res?.data) {
          this.allModulesPluzzNumber = Array.isArray(res.data.data) ? res.data.data.length : null
        }
      })

      // Récupérer les infos du module pluzz
      await getAPI.get(`module_pluzz/${this.$route.params.id}/`).then((response) => {
        if (response.status === 200) {
          this.modulePluzzPayLoad = response.data?.data
        }
      })

      // Récupérer les stats existantes de l’utilisateur (même endpoint utilisé côté preview Pluzz)
      await getAPI.get(`stat_module/?user_id=${localStorage.user}`).then(res => {
        if (res.status == 200 && res?.data) {
          this.allStatModulesPluzz = res.data
        }
      })

      // Créer/mettre à jour la stat du module et récupérer le lien de lecture
      await getAPI.post(`start_module_pluzz/`, {
        module_pluzz: this.$route.params.id,
        user: localStorage.user,
      }).then((response) => {
        if (response.status === 201) {
          this.current_stat_module_pluzz = response.data.data
          // Use localized content logic for the link
          const linkField = this.$i18n.locale === 'en' ? 'link_en' : 'link'
          // Use link_en if available and mode is English, otherwise fallback to link
          this.url_content = (this.$i18n.locale === 'en' && response.data.data[linkField]) ? response.data.data[linkField] : response.data.data.link

          const iframe = document.getElementById('course_iframe')
          if (iframe) {
            iframe.setAttribute('src', this.url_content)
            iframe.src = this.url_content
          }

          const tmpIframe = document.getElementById('course_iframe');
          if (tmpIframe && tmpIframe.contentDocument && tmpIframe.contentDocument.body) {
            tmpIframe.contentDocument.body.innerHTML = "<div style='background: url(https://cci-occitanie.cyberspector.com/favicon.ico); background-position: center; background-repeat: no-repeat; width: 110%;height: 100vh;text-align: center; display: flex; align-items: center;justify-content: center;'><p>Un popup est ouvert</p></div>";
          }
        }
      })

      // Mémoriser la fin potentielle du parcours pour redirection feedback globale
      if (this.allModulesPluzzNumber && this.allModulesPluzzNumber == this.allStatModulesPluzz.length && this.allModulesPluzzNumber == this.modulePluzzPayLoad?.number) {
        this.isLastModulePluzz = true
        localStorage.setItem("isLastModulePluzz", "yes")
        localStorage.setItem("current_stat_module_pluzz", JSON.stringify(this.current_stat_module_pluzz))
      } else {
        localStorage.setItem("isLastModulePluzz", "no")
        localStorage.setItem("current_stat_module_pluzz", JSON.stringify(this.current_stat_module_pluzz))
      }
  }
}
</script>

<style scoped>
.cfa-page{

}
.cfa-block{
  background-color: #fff;
  border-radius: 0.5em;
  padding: .5em 1em;
  box-shadow: -1px 1px 29px 20px rgba(222,234,250,0.87);
  -webkit-box-shadow: -1px 1px 29px 20px rgba(222,234,250,0.87);
  -moz-box-shadow: -1px 1px 29px 20px rgba(222,234,250,0.87);
}
.courseIframe iframe{
    padding: 0;
    overflow-y: hidden;
  }
  .courseIframe{
    width: 100%;
    min-height: 100vh;
  }
  .iframeAction{
    width: 100%;
    height: 5em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    z-index: 1000;
  }
  .bg-summary{
    background-color: #f3f3f3;
  }
</style>


